import { FC, useState } from 'react'
import { UserModule } from '@/core/modules/user/user.module'
import { ASM_DIALOGS_MAP, DialogService } from '@core/services/dialog'
import { SimpleMenu } from '@/ui/components/SimpleMenu'
import { OptionsIcon } from '@atbay/icons'
import { ActionsActivator } from './TeamTable.styles'

export interface TeamRowActionsProps {
    user: TTeamMember
}

const TeamRowActions: FC<TeamRowActionsProps> = ({ user }) => {
    const [isOpen, setIsOpen] = useState(false)

    const menuItems = [
        {
            id: 'delete-user',
            value: 'Delete user',
            action: () =>
                DialogService.showDialog(ASM_DIALOGS_MAP.DELETE_USER, {
                    id: user.user_id,
                }),
            disabled: user.user_id === UserModule.currentUser?.id,
        },
    ]

    return (
        <SimpleMenu
            open={isOpen}
            items={menuItems}
            onClose={() => setIsOpen(false)}
            onActivate={() => setIsOpen((prev) => !prev)}
            openLeft
            activator={
                <ActionsActivator data-testid="team-row-actions">
                    <OptionsIcon />
                </ActionsActivator>
            }
        />
    )
}

export default TeamRowActions
